import * as React from "react";
import { SVGProps } from "react";

export const SVGPullDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="noun-caret-right-1916330 1">
      <path
        id="Vector"
        d="M0 4.56989C8.96454e-05 4.26671 0.12059 3.97595 0.334966 3.76156C0.549341 3.54718 0.840113 3.42676 1.14338 3.42676C1.44656 3.42676 1.73732 3.54717 1.9518 3.76147L8.00373 9.8134L14.0557 3.76147C14.3453 3.47704 14.7641 3.36753 15.156 3.47384C15.5478 3.58005 15.8539 3.88617 15.9601 4.27796C16.0664 4.66984 15.9569 5.0886 15.6725 5.37829L8.81217 12.2386C8.59778 12.4531 8.30693 12.5736 8.00375 12.5736C7.70048 12.5736 7.40965 12.453 7.19533 12.2386L0.335034 5.37829C0.120204 5.16408 -0.000297546 4.87314 6.86646e-05 4.56987L0 4.56989Z"
        fill={props.color || props.fill || "#2B2A27"}
      />
    </g>
  </svg>
);
